import { BdsTooltip, BdsTypo } from 'blip-ds/dist/blip-ds-react/components';
import { ReactNode } from 'react';
import './MetricsContent.scss';
import { FontSize } from 'blip-ds/dist/types/components/typo/typo';
import { TooltipPostionType } from 'blip-ds/dist/types/components/tooltip/tooltip';

type MetricsContentProps = {
    metricsValue?: number | string;
    tooltipText?: string;
    children: ReactNode;
    tooltipPosition?: TooltipPostionType;
};
export function MetricsContent({ metricsValue, tooltipText, tooltipPosition, children }: MetricsContentProps) {
    const windowWidth = window.innerWidth;
    let metricsContentFontSize = 'fs-14';
    let metricsValueFontSize = 'fs-32';
    if (windowWidth < 1400) {
        metricsContentFontSize = 'fs-12';
        metricsValueFontSize = 'fs-24';
    }
    if (windowWidth < 1200) {
        metricsContentFontSize = 'fs-10';
        metricsValueFontSize = 'fs-20';
    }
    return (
        <BdsTooltip
            disabled={tooltipText ? false : true}
            id="tooltip"
            data-testid="metrics-tooltip"
            position={tooltipPosition}
            tooltip-text={tooltipText}
        >
            <div className="metricsBox">
                <BdsTypo
                    className="metricsValue"
                    lineHeight="small"
                    bold="semi-bold"
                    variant={metricsValueFontSize as FontSize}
                >
                    {metricsValue}
                </BdsTypo>
                <BdsTypo
                    style={{ minHeight: '1em', textAlign: 'center' }}
                    data-testid="metrics-content"
                    variant={metricsContentFontSize as FontSize}
                >
                    {children}
                </BdsTypo>
            </div>
        </BdsTooltip>
    );
}
